// extracted by mini-css-extract-plugin
export default {"div":"DestinosImg_div__oZ3Az","h2":"DestinosImg_h2__NVZGR"};